import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { useShipmentData } from './DataProviders';
import { ReactComponent as SignatureIcon } from './signature-icon.svg';


const useStyles = makeStyles( theme => ({
  root: {
    ...theme.signatureRequired,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    padding: '6px 7px',
    fontSize: '10px',
    fontWeight: '500',
    '& svg': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: '5px'
    }
  }
}));


export default function SignatureRequiredTag({ className='' }) {
  const { confirmation_requirement } = useShipmentData();
  const classes = useStyles();

  if( !confirmation_requirement ) {
    return null;
  }

  return (
    <span className={`${classes.root} ${className}`}>
      <SignatureIcon />
      { confirmation_requirement === 'adult' ? 'Adult Signature Required' : 'Signature Required' }
    </span>
  );
}